/**
 * @desc 上传提单附件
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.UploadDeclarationFilesRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationMaster/uploadLadingFile`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
